import { render, staticRenderFns } from "./RepaletizajeForm.vue?vue&type=template&id=4fccf8fb&"
import script from "./RepaletizajeForm.vue?vue&type=script&lang=js&"
export * from "./RepaletizajeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports